import { SkeletonPlaceholder } from '@modernhealth/vital-components';
import React from 'react';

import { CircleGrid } from './CirclePageSection';

export const SessionCardRowSkeleton: React.FC<{ height?: number }> = ({ height = 200 }) => {
    return (
        <CircleGrid>
            <SessionCardSkeleton height={height} />
            <SessionCardSkeleton height={height} />
            <SessionCardSkeleton height={height} />
        </CircleGrid>
    );
};

export const SessionCardSkeleton: React.FC<{ height?: number }> = ({ height = 200 }) => {
    return <SkeletonPlaceholder width="100%" height={height} borderRadius={4} marginBottom={10} />;
};
